// src/pages/PaymentSuccess.js
import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Confetti from "react-confetti";
import { useWindowSize } from "react-use";

const PaymentSuccess = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { width, height } = useWindowSize();

  const jobId = location.state?.jobId || "N/A";
  const amount = location.state?.amount || "N/A";

  const copyToClipboard = () => {
    if (jobId && jobId !== "N/A") {
      navigator.clipboard.writeText(jobId);
      alert("📋 Job ID copied to clipboard!");
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-purple-100 to-indigo-100 p-4 relative overflow-hidden">
      <Confetti width={width} height={height} numberOfPieces={200} />

      <div className="bg-white rounded-2xl shadow-2xl p-8 max-w-xl text-center z-10 w-full">
        <div className="text-5xl mb-4">💸</div>
        <h1 className="text-3xl font-extrabold text-indigo-600 mb-2">
          Payment Successful!
        </h1>
        <p className="text-gray-700 text-lg mb-4">
          You've paid <span className="text-green-600 font-semibold">${amount}</span> for Job ID <span className="text-blue-600 font-semibold">{jobId}</span>
        </p>

        <div className="mb-4">
          <strong className="text-yellow-600">🎫 Job ID:</strong>{" "}
          <span className="text-blue-700 font-semibold">{jobId}</span>
        </div>

        <button
          onClick={copyToClipboard}
          disabled={jobId === "N/A"}
          className={`w-full py-2 px-4 rounded-md text-white text-sm font-semibold transition ${
            jobId === "N/A"
              ? "bg-gray-300 cursor-not-allowed"
              : "bg-indigo-500 hover:bg-indigo-600"
          }`}
        >
          {jobId === "N/A" ? "Job ID Unavailable" : "Copy Job ID"}
        </button>

        <button
          onClick={() => navigate("/your-jobs")}
          className="mt-3 w-full py-2 px-4 rounded-md bg-green-600 hover:bg-green-700 text-white text-sm font-semibold transition"
        >
          View Your Jobs
        </button>

        <p className="mt-4 text-xs text-gray-500">
          Want to view your booking? Head to the job details page 📄
        </p>
      </div>
    </div>
  );
};

export default PaymentSuccess;
